import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { SidebarPortal, BlockDataForm } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import type { ApplicationEditProps, ContentState } from './types';
import View from './View';
import Schema from './schema';

const Edit = (props: ApplicationEditProps) => {
  const { data, onChangeBlock, block, selected, blocksConfig, content } = props;
  const intl = useIntl();

  const formData = useSelector((state: ContentState) => state.form.global);

  const schema = Schema(intl);

  return (
    <>
      <View
        isEdit
        block={block}
        onChangeBlock={onChangeBlock}
        data={data}
        content={formData || content}
      />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          onChangeField={(id: string, value: any) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
          blocksConfig={blocksConfig}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
